import { render } from "./DeviceDetail.vue?vue&type=template&id=e4b2800e&scoped=true"
import script from "./DeviceDetail.vue?vue&type=script&lang=js"
export * from "./DeviceDetail.vue?vue&type=script&lang=js"

import "./DeviceDetail.vue?vue&type=style&index=0&id=e4b2800e&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4b2800e"]])

export default __exports__